import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import Paper from 'material-ui/Paper'
import List, {ListItem, ListItemText, ListItemSecondaryAction} from 'material-ui/List'
import Avatar from 'material-ui/Avatar'
import AccountCircleIcon from 'material-ui-icons/AccountCircle'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import ClearIcon from 'material-ui-icons/Clear'
import IconButton from 'material-ui/IconButton'

import {withOthers as text} from '../text'
import {withOthers as styles} from '../styles'
import HeaderProgress from '../../../common/components/HeaderProgress'
import ErrorMessage from '../../../common/components/ErrorMessage'
import Share from '../containers/share'
import Revoke from '../containers/revoke'

class WithOthers extends React.Component {

  renderNoCatalogsMessage = (classes, setOpenShare) => (
    <div>
      <Share/>
      <div className={classes.buttonContainer}>
        <Button
          variant="raised"
          color="primary"
          type="submit"
          className={classes.button}
          style={{marginTop: '15px'}}
          onClick={() => setOpenShare(true)}
        >
          {text.share}
        </Button>
      </div>
      <Typography variant="title" className={this.props.classes.noCatalogsMessage}>
        {text.noCatalogsMessage}
      </Typography>
    </div>
  )

  render() {
    const {classes, catalogs, isFetching, error, setOpenShare, setOpenRevoke} = this.props
    if (isFetching === true) return <HeaderProgress show={isFetching}/>
    if (error !== '') return <ErrorMessage error={error}/>
    if (catalogs.length === 0) return this.renderNoCatalogsMessage(classes, setOpenShare)
    return (
      <div className={classes.container}>
        <Revoke/>
        <Share/>
        <div className={classes.buttonContainer}>
          <Button
            variant="raised"
            color="primary"
            type="submit"
            className={classes.button}
            onClick={() => setOpenShare(true)}
          >
            {text.share}
          </Button>
        </div>
        <Paper>
          <List>
            {catalogs.map(c => (
              <ListItem key={c.ID} dense>
                {c.ProfilePicture && c.ProfilePicture !== ''
                  ? <Avatar className={classes.avatar} src={c.ProfilePicture} alt="user"/>
                  : <Avatar className={classes.avatar}><AccountCircleIcon/></Avatar>
                }
                <ListItemText primary={c.Name + ' ' + c.LastName} secondary={c.Email}/>
                <ListItemSecondaryAction>
                  <IconButton onClick={() => setOpenRevoke(true, c.ID, c.Email)}><ClearIcon/></IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </Paper>
      </div>
    )
  }
}

WithOthers.propTypes = {
  setOpenShare: PropTypes.func.isRequired,
  setOpenRevoke: PropTypes.func.isRequired,
  catalogs: PropTypes.array.isRequired,
  isFetching: PropTypes.bool,
  error: PropTypes.string,
}

export default withStyles(styles)(WithOthers)



// WEBPACK FOOTER //
// ./src/sections/shared/components/withOthers.js